import { MessageThread, PopulatedThreadMessage, Reaction, ThreadType, WithId } from '@hb/shared'

const testReactions: Reaction[] = [
  {
    createdBy: '123',
    createdByGroup: 'admin',
    createdOn: 0,
    type: 'like',
  },
  {
    createdBy: '456',
    createdByGroup: 'admin',
    createdOn: 0,
    type: 'confused',
  },
]

const now = Date.now()

const getTestMessageCreatedOn = (index: number, total: number) =>
  now - (total - index) * 1000 * 30 * Math.random()

export const testMessage: PopulatedThreadMessage = {
  createdBy: '123',
  createdByGroup: 'admin',
  createdOn: getTestMessageCreatedOn(0, 2),
  text: 'Hello, world!',
  threadType: ThreadType.GROUP,
  threadId: '123',
  updatedOn: getTestMessageCreatedOn(0, 2),
  updatedBy: '123',
  updatedByGroup: 'admin',
  dateString: '06/03/2025',
  messageGroupId: '123',
  sentBySameAsPrevious: false,
  sentByMe: true,
  sentBySameAsNext: false,
  reactions: testReactions,
  messageGroupCreatedOn: getTestMessageCreatedOn(0, 2),
  sentAtSameTimeAsPrevious: false,
  id: `${getTestMessageCreatedOn(0, 2)}`,
  readBy: ['456'],
  readOn: {
    '456': Date.now(),
  },
  sentAtSameTimeAsNext: false,
  sentAtSameDateAsNext: false,
  sentAtSameDateAsPrevious: false,
  timeString: '12:00',
}

export const testMessage2: PopulatedThreadMessage = {
  ...testMessage,
  createdBy: '456',
  createdByGroup: 'admin',
  updatedOn: getTestMessageCreatedOn(1, 2),
  createdOn: getTestMessageCreatedOn(1, 2),
  sentBySameAsPrevious: true,
  sentByMe: false,
  sentBySameAsNext: true,
  sentAtSameTimeAsPrevious: true,
  sentAtSameTimeAsNext: true,
  sentAtSameDateAsNext: true,
  sentAtSameDateAsPrevious: true,
  text: 'Hello, world!',
  id: `${getTestMessageCreatedOn(1, 2)}`,
}

export const testMessages: PopulatedThreadMessage[] = [testMessage, testMessage2]

export const testThread: WithId<MessageThread> = {
  id: 'test-thread',
  accessLevel: 'admin',
  type: ThreadType.GROUP,
  subscribers: ['123', '456', '789'],
  mostRecentMessages: testMessages,
  mostRecentMessageOn: Date.now(),
  mostRecentMessageBy: '123',
  searchString: '',
  readBy: [],
  unreadBy: [],
  title: 'Test Thread',
}
